<template>
  <div id="app_open_event">
    <div class="event_wrap">
      <img  class="event_img" src="../assets/img/main/adBar/open_event.jpg" alt="">
      <div class="m_wrap_app_event" v-if="!this.isApp">
        <div v-if="this.iosFlag === true">
          <a class="m_ev_button" href="https://apps.apple.com/kr/app/%EC%97%94%ED%83%80%EB%B9%84-%EC%9D%BC%EB%B3%B8-%EA%B0%88-%EB%95%90-%EC%97%94%ED%83%80%EB%B9%84-%EC%9D%BC%EB%B3%B8-%EB%B2%84%EC%8A%A4%ED%88%AC%EC%96%B4-%EC%97%94%EB%8D%B0%EC%9D%B4%ED%8A%B8%EB%A6%BD/id6745860846" target="_blank">앱 다운받기</a>
        </div>
        <div v-else>
          <a class="m_ev_button" href="https://play.google.com/store/apps/details?id=com.eUoPfDyrvZ.ZBqPiAIqvO" target="_blank">앱 다운받기</a>
        </div>
        <img class="event_img_m" src="../assets/img/main/adBar/app_img_m.jpg" alt="">

      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobileDisplay: false,
      isApp: false,
      iosFlag: false
    }
  },
  created() {
    // 유저디바이스체크 (모바일처리용)
    if (this.$isMobile()) 
    {
      this.mobileDisplay = true;
    } 
    else 
    {
      this.mobileDisplay = false;
    }    
  },
  computed: { 
  },
  methods: {
    goToDetail(productId, salesRoute) {
      this.$router.push({path: '/detail', query: {productId: productId, salesRoute:salesRoute}});
    }
  },
  mounted() {
    console.log("mobileDisplay:", this.mobileDisplay)
    // 구동환경 체크
    if (window.Nachocode.env.isApp()) 
    {
      this.isApp = true;
      console.log('isApp:', this.isApp);
    }
    else 
    {
      this.isApp = false;
      console.log('isApp:', this.isApp);
    }

    if(window.Nachocode.device.isIOS()) 
    {
      this.iosFlag = true
      console.log('iosFlag:', this.iosFlag);
    }
    else 
    {
      this.iosFlag = false
      console.log('iosFlag:', this.iosFlag);
    }    
  }
}

</script>

<style scoped>
  #app_open_event{
    margin-top: -6rem;
    }
  .event_wrap{
    width: 100%;
    text-align: center;
  }
  .event_img{
    width: 100%;
  }
  .event_img_m{
    display: none;
  }
  .m_ev_button{
    display:none;
  }
  @media(max-width:1024px){
  .event_img {
    display: none;
  }
  .event_img_m {
    display: inline;
    width: 100%;
  }

  #app_open_event {
    margin-top: 2rem;
  }

  .m_wrap_app_event {
    width: 100%;
    height: auto;
    position: relative;
  }

  .m_ev_button {
    display: block;
    width: 200px;
    height: 80px;
    background-color: #54df4b;
    position: absolute;
    top: 73%;
    left: 5%;
    z-index: 10;
    border-radius:10px;
    color: #fff;
    font-weight: bold;
    font-size: 20pt;
    text-align: center;
    padding-top: 1rem;
    border: 3px solid #fff;
    box-shadow: 3px 3px 3px  rgba(0, 0, 0, 0.4);
  }
}
</style>